const BackImageModel = require("@/appModel/BackImage/BackImageModel");
const ShapeModel = require("@/appModel/BackImage/ShapeModel");
const TreeModel = require("@/appModel/Tree/TreeModel");
const TreeItemModel = require("@/appModel/Tree/TreeItemModel")
const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const TenantStorage = require("@/appUtils/TenantStorage")
const short = require("short-uuid");
const path = require("path")
const SortUtil = require("@/appUtils/SortUtil")

class FormSettingViewModel {
  constructor(tenantId, projectId, parentNode = null, nodeId = null) {
    this.tenantId = tenantId
    this.isNew = true 
    this.nodeId = nodeId
    this.projectId = projectId
    this.backImage = null
    this.treeItem = null
    this.formList = []
    this.backImageCopySourceList = []
    this.figureCopySourceList = []
    // 親ノードオブジェクト({id: String, sk: String, label: String})
    this.parentNode = parentNode
    // 背景図コピーの場合の元レコード情報
    this.originBackImage = null
    // 手書きコピーの有無
    this.isCopyShape = false
    
    
  }
  /**
   * 初期処理
   */
  async init() {
   
    // 新規フラグ更新(skが指定されていれば既存レコード)
    this.isNew = !this.nodeId
    this.tenantStorage = new TenantStorage(this.tenantId)

    if (!this.isNew) {
      // DBから取得
      try {
        // ノード情報を取得
        const nodeSk = TreeItemModel.createSk(this.projectId, this.nodeId)
        this.treeItem= await TreeItemModel.get(nodeSk, this.tenantId)
        // ノードに紐づく背景図情報を取得
        const backImageSk = BackImageModel.createSk(this.projectId, this.treeItem.treeItem.id)
        this.backImage = await BackImageModel.getBackImage({sk: backImageSk}, this.tenantId) 
        if (!this.backImage) {
          // もし未作成ならば背景図設定新規レコード
          this.backImage = await BackImageModel.getNewBackImageData(this.projectId, this.treeItem.treeItem.id)
        }
      } catch (e) {
        console.log(`ProjectEditViewModel init error ${e}`)
        throw e
      }
    } else {
      // ツリーアイテム新規レコード
      // this.treeItem = await TreeItemModel.getNewData(this.parentSk)
      
      this.treeItem = await TreeItemModel.getNewData(this.projectId)
      this.treeItem.lsiStr1 = this.parentNode.sk
      this.treeItem.lsiInt1 = this.parentNode.lsiInt1 + 1
    
      this.treeItem.treeItem.type = "backimage"
      
      // 背景図設定新規レコード
      this.backImage = await BackImageModel.getNewBackImageData(this.projectId, this.treeItem.treeItem.id)
      
      this.nodeId = this.treeItem.treeItem.id
    }

    // フォーム設定を取得
    this.formList = (await InspectMasterModel.getInspectMasterList(this.tenantId)).filter(function(item) {
      return !item._deleted === true
    });
    this.formList = await SortUtil.sort(this.formList, "inspectMaster.name", "ascending", true);

    // 背景図コピー用のリスト取得
    this.backImageCopySourceList = (await BackImageModel.getBackImageList(this.projectId, null, this.tenantId)).filter(function(item) {
      return item.backImage
    }.bind(this))

    // 手書きコピー用のリスト取得
    this.figureCopySourceList = JSON.parse(JSON.stringify(this.backImageCopySourceList))

  }
  
  async save() {
    try {

      if (this.isNew) {
        // 新規追加
        
        // ツリー項目を登録
        this.treeItem.treeItem.label = this.backImage.backImage.name
        await TreeItemModel.add(this.treeItem)
        
        // 背景図コピーの場合のSource
        if (this.originBackImage) {
          // ファイル名を取得
          const fileName = path.basename(this.originBackImage.backImage.filePath)
          // S3keyを構成
          this.backImage.backImage.filePath = this.tenantStorage.createBackImageKey(this.projectId, this.nodeId, fileName)
          // 背景図コピー
          
          await this.tenantStorage.copy(this.originBackImage.backImage.filePath, this.backImage.backImage.filePath)
        }

        // 背景図を登録
        await BackImageModel.addBackImage(this.backImage)

        // 手書きコピーの有無
        if (this.isCopyShape) {
          let originKeys = this.originBackImage.sk.split("#")
          let originNodeId = originKeys[originKeys.length - 1]
          
          // 手書き情報をコピーする
          const shapeList = await ShapeModel.getShapeList(this.projectId, originNodeId, this.tenantId)
          for (let i = 0;i < shapeList.length;i++) {
            const id = short.generate()
            let sk = ShapeModel.createSk(this.projectId, this.nodeId, id)
            // キーを新たに作成
            shapeList[i].sk = sk
            // idを削除
            delete shapeList[i].id

            await ShapeModel.addShape(shapeList[i])
          }
        }

      } else {
        // 更新
        
        // 階層名更新
        this.treeItem.treeItem.label = this.backImage.backImage.name
        // ツリー項目を更新
        await TreeItemModel.update(this.treeItem)

        // 背景図を更新
        await BackImageModel.updateBackImage(this.backImage)
      }
    } catch (e) {
      console.log(`FormSettingViewModel save error:${JSON.stringify(e)}`)
      throw e
    }
  }

  async delete() {
    try {
      await BackImageModel.deleteBackImage(this.backImage)
    } catch (e) {
      console.log(`FormSettingViewModel delete error:${JSON.stringify(e)}`)
      throw e
    }
  }
  
}
module.exports = FormSettingViewModel;